import { SelectInputV2, SelectInputV2Props, SelectOption } from '@frontend/components/basic-forms';
import { NodeType } from '@frontend/group/types';
import React from 'react';

const ID = 'group-node-type-select';
export interface GroupNodeTypeSelectV2Props extends Omit<SelectInputV2Props<NodeType>, 'options'> {
    options?: SelectOption<NodeType>[];
}

export const GroupNodeTypeSelectV2 = (props: GroupNodeTypeSelectV2Props) => {
    const options = Object.values(NodeType).map((type) => {
        return {
            value: type,
            label: type
        };
    });

    return (
        <SelectInputV2<NodeType>
            {...props}
            id={ID + props.id}
            label={props.label || 'Node type'}
            options={props.options || options}
        />
    );
};
